/**
 * Theme bridge for Who Am I? UI overlays.
 *
 * Re-exports `applyTheme` + `DEFAULT_THEME` from the scene/lib copy and adds
 * a `getThemeVar` helper that reads a CSS custom property as a `#RRGGBB`
 * string (used by sparkles + countdowns that can't consume CSS vars directly).
 *
 * Mirrors `games/whatis/browser/src/ui/theme.ts` so copied helpers
 * (sparkles, countdown, etc.) work without import edits.
 */

export { DEFAULT_THEME, applyTheme } from '../scene/lib/theme.js';

function cssNameFor(slot: string): string {
  if (slot === 'background') return '--sg-bg';
  return `--sg-${slot.replace(/_/g, '-')}`;
}

/**
 * Read a theme CSS custom property as a `#RRGGBB` string. Falls back to
 * `fallback` when the property is unset or malformed.
 */
export function getThemeVar(name: string, fallback: string): string {
  if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') {
    return fallback;
  }
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(cssNameFor(name))
    .trim();
  return /^#[0-9A-Fa-f]{6}$/.test(raw) ? raw : fallback;
}
